<script>
  import { onMount } from "svelte"
  import { getRequest } from "../../../../Script/apiMethods"
  import { push, querystring } from "svelte-spa-router"
  import Footer from "../../../../Shared/footer.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import Table from "../../../../Shared/Table/table.svelte"
  import List from "./Components/cardList.svelte"
  import Filter from "./Components/filterComponent.svelte"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import notify from "../../../../Script/notify"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching List of Seal"
  /**
   * @type {Boolean} for showing Loader while loading the list of file templates
   */
  let showLoading = false

  let limit
  let page
  let sort
  let sortBy
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  let startDate = null
  let endDate = null

  /**
   * @type {String} - which state document need to show
   */
  let status = null
  let seals = []

  let fileCount

  let query

  // List page api -fetch all list of templates.
  onMount(async () => {
    try {
      // Prevent execution if unauthorized (because pop() is asynchronous)
      if (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken) return

      query = queryStringToJSON($querystring)

      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      status = query.state ? query.state : "active"
      search.searchParam = query.sin ? query.sin : "name"
      if (query.sname) search.searchvalue = query.sname

      await fetchSeals()
    } catch (error) {
      const info = "PAGE: Seal List\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const fetchSeals = async () => {
    try {
      showLoading = true

      const data = await getRequest(`/api/pdf-signing/v2/seal?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      // console.log(data)

      fileCount = data.count
      seals = data.seals || []
      push(`/signing/seal?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`)
    } catch (error) {
      throw error
    } finally {
      showLoading = false
    }
  }

  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      status = e.detail.filter.mode ? e.detail.filter.mode : status
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchSeals()
    } catch (error) {
      const info = "PAGE: Seal List\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name/ status, or navigating pages."
      notify.danger(error, info)
    }
  }

  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = 1
      sortBy = "date"
      search.searchvalue = ""
      startDate = null
      endDate = null
      status = "active"
      await fetchSeals()
    } catch (error) {
      const info = "PAGE: Seal List\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>List of Seal</title>
</svelte:head>

{#if showLoading}
  <LoadingScreen msg={loadingText} />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="px-6 pb-12 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        on:click={() => {
          push(`/signing/seal/edit`)
        }}
        class="absolute right-0 top-0 z-10 flex h-9 w-max min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500"
      >
        <span>
          <i class="fa-solid fa-plus" />
        </span>
        <span class="hidden sm:block">&nbsp;Add Seal</span>
        <span class="block sm:hidden">&nbsp;Add</span>
      </div>

      <Table on:changeEntries={whileChangingEntries} entriesList={[10, 50, 100]} title="List of Seal" filterComponent={Filter} jsonData={seals} count={fileCount} filter={true} on:resetEntries={resetList}>
        {#if seals.length}
          <div class="w-full space-y-3">
            {#each seals as seal}
              <List {seal} />
            {/each}
          </div>
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There are no Seals</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
